import Client from 'config/axios';
import posthog from 'posthog-js';

interface BonusData {
  challengeId: number;
  records: any;
  notificationEmail?: string;
}

export const uploadBonusExcel = async (token: string, BonusData: BonusData) => {
  try {
    const { data } = await Client.post('bonus/excel', BonusData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    posthog.capture('UploadBonusExcel', {
      UploadBonusExcel: data
    });

    return {
      data: data,
      errors: data.errors || null
    };
  } catch (response) {
    const result = response as any;
    return {
      data: null,
      errors: result.response?.data || result.data || result.message
    };
  }
};
